module.exports = __webpack_public_path__ + "static/media/11b_hero_desktop.f4b5cd0e.jpg";